import * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * shadcn-style Textarea primitive — added for W3-F3-S2 BREEAM long-text
 * variable inputs.
 */
export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        className={cn(
          // HARMONIZATION.md § 14: shadow-focus-blue replaces Tailwind ring.
          'flex min-h-[80px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:shadow-[var(--shadow-focus-blue)] disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        {...props}
      />
    );
  },
);
Textarea.displayName = 'Textarea';

export { Textarea };
